// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {531: "a4a27b48931502c9",731: "ae8146cec9f00b88",}[chunkId] + ".css"
}